import React from "react";
import { X } from "react-feather";
import { useIntl } from "react-intl";
import { useState } from "react";
import "./styles.scss";

const ExtratoDap = ({ onClose, onSave, setError }) => {
  const { formatMessage } = useIntl();
  const [dataNascimento, setDataNascimento] = useState(null);

  function handleSave() {
    let match = /^(0[1-9]|[12][0-9]|3[01])[-/.](0[1-9]|1[0-2])[-/.][0-9]{4}$/.exec(dataNascimento);
    if (match) {
      const unifiedDate = match[0].replace(/[-/.]/g, '/');
      const [day, month, year] = unifiedDate.split('/');
      const formattedDate = `${day}/${month}/${year}`;
      onSave(formattedDate);
    } else {
      setError(formatMessage({ id: "erro-data-dap" }));
    }
    onClose();
  }

  return (
    <>
      <div className="modal extrato-dap-modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card" id="modal-data-nascimento">
          <header className="modal-card-head">
            <div className="modal-card-title">
              {formatMessage({ id: "titulo-cpf-dap" })}
            </div>
            <X
              data-testid="close-button"
              className="close-button"
              onClick={onClose}
            />
          </header>
          <section className="modal-card-body">
            <div className="control">
              <span className="modal-card-subtitle">{formatMessage({ id: "dap-data-formatos" })}</span>
              <br />
              <br />
              <input
                className="input"
                type="text"
                maxLength="10"
                id="report-title"
                placeholder="DD/MM/AAAA"
                value={dataNascimento}
                onChange={e => setDataNascimento(e.target.value)}
              />
            </div>
          </section>
          <footer className="modal-card-foot">
            <button className="button" onClick={onClose}>
              {formatMessage({ id: "cancelar" })}
            </button>
            <button
              className={`button primary`}
              disabled={!dataNascimento}
              onClick={handleSave}
            >
              {formatMessage({ id: "continuar" })}
            </button>
          </footer>
        </div>
      </div>
    </>
  );
};

export default ExtratoDap;
